import { FunctionComponent } from "react";

import { SelectField } from "@/components/SelectField/SelectField";
import { FundingCategories, FundingCountries, FundingRoundsValues } from "@/enum/funding-ma.enum";

import { FundingConfig, MnaConfig } from "../onboardingListTypes";
import { ConfigField, ConfigGrid, useConfigTranslation, useFieldError } from "./ConfigField";
import { ConfigFormProps } from "./configFormProps";
import { OptionMultiField } from "./FilterFields";

const LOOKBACK_DAYS = [30, 90, 365];

/**
 * FUNDING_ROUNDS — both modes share the country / sector / lookback filters;
 * only the funding mode also picks the rounds.
 */
export const FundingForm: FunctionComponent<ConfigFormProps<FundingConfig | MnaConfig>> = ({
	value,
	errors,
	onChange,
}) => {
	const ts = useConfigTranslation();
	const errorFor = useFieldError(errors);

	return (
		<ConfigGrid>
			<OptionMultiField
				error={errorFor("fundingFilters")}
				label={ts("fundingCountries")}
				options={FundingCountries}
				placeholder={ts("fundingCountriesPlaceholder")}
				values={value.countries}
				onChange={(countries) => onChange({ ...value, countries })}
			/>

			<OptionMultiField
				label={ts("fundingCategory")}
				options={FundingCategories}
				placeholder={ts("fundingCategoryPlaceholder")}
				values={value.category}
				onChange={(category) => onChange({ ...value, category })}
			/>

			{value.kind === "funding" && (
				<OptionMultiField
					label={ts("fundingRound")}
					options={FundingRoundsValues}
					placeholder={ts("fundingRoundPlaceholder")}
					values={value.round}
					onChange={(round) => onChange({ ...value, round })}
				/>
			)}

			<ConfigField label={ts("lastXDays")}>
				<SelectField
					hideEmptyValue
					handleSelect={(lastXDays) => onChange({ ...value, lastXDays: Number(lastXDays) })}
					options={LOOKBACK_DAYS.map((days) => ({ title: ts(`lastXDays${days}`), value: days }))}
					selectedOption={value.lastXDays}
					testId="onboarding-funding-lastXDays"
				/>
			</ConfigField>
		</ConfigGrid>
	);
};
